import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EditIconPencil, RedTrash } from '../../../Assets/icons';
import AddEditServiceItem from '../AddEditServiceItem';
import CommonCard from '../CommonCard';
import NoDataFound from '../NoDataFound';
import classes from './DecideServiceList.module.css';
import {
  decrementQuantityInSelectedServiceList,
  addQuantityInSelectedServiceList
} from '../../../Store/serviceSlice';
const DecideServiceList = ({
  setter,
  onEditService,
  onDeleteService,
  selected,
  onSelect,
  value
}) => {
  const dispatch = useDispatch();
  const findEleInSelectedList = (arr, obj) => {
    return arr?.find((ele) => ele?.serviceId == obj?.serviceId);
  };
  const selectedServices = useSelector((state) => state?.serviceReducer?.selectedServices);

  return (
    <CommonCard className={clsx(classes.mainWrapper,)}>
      {value?.filter((e) => e?.serviceId != null)?.length > 0 ? (
        <>
          {/* All services render */}
          {value
            ?.filter((e) => e?.serviceId != null)
            ?.map((item, index) => {
              return (
                <div className={classes.itemWrapper}>
                  <AddEditServiceItem data={{ ...item }} arr={selected} setArr={onSelect}>
                    <div className={classes.selectService}>
                      <span
                        className={classes.actionButton}
                        onClick={() => {
                          // setServiceList(updatedService);
                          dispatch(decrementQuantityInSelectedServiceList(item?.serviceId));
                        }}>
                        -
                      </span>
                      <input
                        step={1}
                        type="number"
                        min={0}
                        value={findEleInSelectedList(selectedServices, item)?.quantity || 0}
                        onChange={(e) => {
                          let updatedService = [...selectedServices];
                          updatedService[index] = {
                            ...updatedService[index], // Copy the existing item
                            quantity: e?.target?.value // Increment quantity
                          };
                          // setServiceList(updatedService);

                          dispatch(addQuantityInSelectedServiceList(item));
                        }}
                      />
                      <span
                        className={classes.actionButton}
                        onClick={() => {
                          dispatch(addQuantityInSelectedServiceList(item));
                          // Find the index of the service to update
                        }}>
                        +
                      </span>
                    </div>
                  </AddEditServiceItem>
                  <span
                    onClick={() => {
                      setter({ ...item, quantity: 1 });
                      onEditService(item);
                    }}>
                    <CommonCard className={classes.quickAction}>
                      <EditIconPencil />
                    </CommonCard>
                  </span>
                  <CommonCard
                    className={classes.quickAction}
                    onClick={() => {
                      if (typeof onDeleteService === 'function') {
                        onDeleteService();
                        setter({ ...item, quantity: 1 });
                      }
                    }}>
                    <RedTrash />
                  </CommonCard>
                </div>
              );
            })}
        </>
      ) : (
        <NoDataFound label="No Service Found" />
      )}
    </CommonCard>
  );
};

export default DecideServiceList;
